<template>
  <div>
    <b-card no-body="">
      v-show="!isLoading" v-if="isLoading"
      <div slot="header">
        <strong>{{ $lang.base_info }}</strong>
        <div class="float-right">
          <b-button @click="isCollpased = !isCollpased" variant="success">
            <i aria-hidden="true" class="fa fa-angle-down"></i>
          </b-button>
        </div>
      </div>
      <b-collapse v-model="isCollpased" class="mt-2">
        <b-form @submit.prevent="submit">
          <b-overlay :show="isOverlay" :opacity="0.3">
            <b-row>
              <b-col xs="12" md="12">
                <b-form-group
                  :label="$lang.caption_content"
                  label-for="caption"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.caption_content"
                    :rules="$v.caption.$params"
                  />
                  <b-form-input
                    id="caption"
                    type="text"
                    :autocomplete="$lang.caption_content"
                    v-model="$v.caption.$model"
                    :state="$v.caption.$dirty ? !$v.caption.$error : null"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="caption-feedback">
                    {{ $lang.error_required | replace($lang.caption_content) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col xs="12" md="12">
                <requiredComponent
                  slot="label"
                  :label="$lang.description_content"
                  :rules="$v.description.$params"
                />
                <editor dir="rtl" v-model="description">
                  <br />
                </editor>
                <b-form-invalid-feedback id="name-feedback">
                  {{
                    $lang.error_required | replace($lang.description_content)
                  }}</b-form-invalid-feedback
                >
              </b-col>
            </b-row>
          </b-overlay>

          <b-row>
            <b-col xs="12" md="12">
              <div slot="footer" class="form-group form-btn">
                <b-button type="submit" size="md" variant="success">
                  {{ $lang.submitButton }}
                  <i class="fa fa-check"></i>
                </b-button>

                <b-button
                  class="ml-2"
                  size="md"
                  variant="danger"
                  @click="handleBack"
                >
                  {{ $lang.cancelButton }}
                  <i class="fa fa-ban"></i>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-collapse>
    </b-card>
  </div>
</template>
<script>
import editor from "@/components/ckeditor/editor";
import { required } from "vuelidate/lib/validators";

export default {
  validations: {
    caption: {},
    description: {},
  },
  components: {
    editor,
  },
  props: {
    showDragFile: {
      type: Boolean,
      default: false,
    },
    attachmentId: {
      type: String,
      default: "",
    },
    keyServies: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      default: () => {},
    },
    isOverlay: {
      type: Boolean,
      default: false,
    },
    showAlert: {
      type: Boolean,
      default: true,
    },
    taskId: {
      type: [String, Number],
      default: "",
    },
    mode: {
      type: String,
      default: "",
    },
    // fileUpload:{
    //   type:[Array,fileList],
    //   default: () => []
    // }
  },
  name: "person-content-form",
  data() {
    return {
      isLoading: true,
      isCollpased: false,
      acceptFormatsInput: "",

      acceptFormats: [
        {
          caption: "عکس",
          value: "10MB",
        },
        {
          caption: "مجموعه آفیس",
          value: "20MB",
        },
        {
          caption: "ویدیو/صوت",
          value: "50MB",
        },
        {
          caption: "بقیه فایل‌ها",
          value: "10MB",
        },
      ],
      editor: "ClassicEditor",
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "bulletedList",
          "numberedList",
          "blockQuote",
        ],
        // The configuration of the editor.
        language: {
          // language: fa,
          // The UI will be fa.
          ui: "fa",
          // But the content will be edited in fa.
          content: "fa",
        },
      },
      description: null,
      caption: null,
      fileUpload: [],
      responseCode: [],
      btnHidden: false,
    };
  },
  methods: {
    attachmentTemp(files) {
      this.btnHidden = true;
      this.fileUpload = [...this.fileUpload, ...files];
      // this.$emit("attachmentTemp", files)
    },
    submit() {
      let payload = {
        name: this.caption,
        description: this.description,
        reference: {
          task: this.taskId,
        },
      };
      this.$emit("submit", payload);
    },
    handleBack() {
      this.$emit("closeModal");
    },
    removeFileProgress(item) {
      let indexFile = this.fileUpload.indexOf(item);
      let response = this.responseCode.find((x) => x.name == item.name);
      let indexResponse = this.responseCode.indexOf(response);
      this.fileUpload.splice(indexFile, 1);
      this.responseCode.splice(indexResponse, 1);
      this.$refs.fileDrag.$refs.fileupload.value = "";
    },
    filesCode(code) {
      this.responseCode = code;
      this.$emit("responseCode", this.responseCode);
    },
    fetchData() {
      if (this.item && Object.keys(this.item).length > 0) {
        this.caption = this.item.name;
        this.description = this.item.description;
      }
    },
  },

  created() {
    this.fetchData();
  },
};
</script>
